<!-- Map Settings -->
@if (isMapWidget) {
  <div>
    <form [formGroup]="widgetForm" class="row">
      <div class="col-6">
        <div class="form-group">
          <label for="zoomLvl" class="form-label" translate>Zoom level</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <span class="fa-solid fa-magnifying-glass"></span>
              </span>
            </div>
            <input id="zoomLvl"
              formControlName="zoomLvl"
              type="number"
              [min]="getMaxMinZoom('min')"
              [max]="getMaxMinZoom('max')"
              [placeholder]="'Zoom level' | translate"
              class="form-control"
              (change)="replaceInvalidValue($event)">
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <span class="form-label" translate>View</span>
          <div class="btn-group d-flex btn-group-toggle" ngbRadioGroup formControlName="mapType">
            <label ngbButtonLabel class="btn btn-outline-primary w-50"
              [class.active]="f.mapType.value === mapTypeId.ROADMAP">
              <input ngbButton type="radio" (click)="f.mapType.setValue(mapTypeId.ROADMAP)">
              <span translate>Map</span>
            </label>
            <label ngbButtonLabel class="btn btn-outline-primary w-50"
              [class.active]="f.mapType.value === mapTypeId.HYBRID">
              <input ngbButton type="radio" (click)="f.mapType.setValue(mapTypeId.HYBRID)">
              <span translate>Satellite</span>
            </label>
          </div>
        </div>
      </div>
    </form>
      <!--Map-->
      <span class="form-label" translate>Map preview</span>
      <div class="google-map-container">
        @if (googleMapsLoaded) {
          <google-map
            #googleMap="googleMap" (wheel)="onWheel($event)" (zoomChanged)="onZoomChanged()" id="widget-map"
            [mapTypeId]="f.mapType.value"
            [options]="mapOptions"
            [zoom]="+f.zoomLvl.value"
            width="100%" height="350">
            <map-marker [options]="marker.get('options')"
              #mapMarker="mapMarker"
              [position]="marker.get('position')"
            (mapClick)="onOpenInfoWindow(mapMarker, infoWindow)"></map-marker>
            <map-info-window #infoWindow="mapInfoWindow" (closeclick)="onCloseInfoWindow()">
              <div class="p-1" style="min-width: 160px;">
                <h6 class="h6 mb-2 truncate" [innerText]="marker.getTitle() || ''"></h6>
                <div class="map-info-address mb-2" [innerText]="machineAddress()"></div>
                <button type="button"
                  (click)="redirectToGoogleMaps()"
                  class="btn btn-sm btn-outline-primary btn-block">
                  <i class="fa-solid fa-route"></i>
                  <span translate>Show on maps</span>
                </button>
              </div>
            </map-info-window>
          </google-map>
        } @else {
          <div class="d-flex align-items-center justify-content-center w-100" style="height: 350px">
            <div class="text-center">
              <div class="mb-2 display-4 text-primary">
                <span class="fa-solid fa-spinner fa-spin"></span>
              </div>
              <p>
                <b translate>Loading map</b><br>
                <span class="text-center" translate>Please wait ...</span>
              </p>
            </div>
          </div>
        }
      </div>
    </div>
  }

